// http://vuex.vuejs.org/en/getters.html
import { isEmpty } from "lodash";
import { decode } from "jwt-simple";
import { isAuthDisabled } from "../services";
import * as CONFIG from "../../../config";
import { MergePermissions } from "@/vue-ocom/auth/store/permissions";

// if has token, we assume that user is logged in our system
export const isLoggedIn = function ({ token }) {
    if (isAuthDisabled()) {
        return true; // always "logged in"
    }

    var result = !isEmpty(token);

    if (result) {
        try {
            decode(token, process.env.VUE_APP_ROOT_JWT_KEY);
        } catch (err) {
            // Something went wrong either the token is not valid or expired etc.
            result = false; // there is a problem
        }
    }
    return result;
};

// get current user data
export const currentUser = function ({ user }) {
    if (isAuthDisabled()) {
        // Create a Dummy user as per https://docs.djangoproject.com/en/3.0/ref/contrib/auth/#django.contrib.auth.models.User.is_authenticated
        return {
            pk: null,
            id: null,
            username: "anonymous",
            first_name: "Ann",
            last_name: "Onymous",
            groups: [],
            user_permissions: [],
            is_staff: false,
            is_active: true,
            is_superuser: false,
            is_authenticated: false,
            is_anonymous: true,
        }; // always "logged in"
    }

    return user;
};

export const token = function ({ token }) {
    if (isAuthDisabled()) {
        return "ANONYMOUS_TOKEN";
    }

    return token;
};

// Get the permissions
export const permissions = function ({ permissions }) {
    if (isAuthDisabled()) {
        return {};
    }

    return MergePermissions(CONFIG.DefaultPermissions, permissions);
};

export const use_permissions = function ({ use_permissions }) {
    if (isAuthDisabled()) {
        return false; // don't use permissions there are none
    }

    return use_permissions;
};
